import { useEffect } from 'react'

import { Drawer, Loading } from '@reveni-io/reveni-ui'

import useBankAccount from '@/hooks/useBankAccount/useBankAccount'

import Header from './Header/Header'
import useManageSteps from './hooks/useManageSteps/useManageSteps'
import BankAccountStep from './steps/BankAccountStep/BankAccountStep'
import VerifyAccountStep from './steps/VerifyAccountStep/VerifyAccountStep'
import { steps } from './constants'
import * as Styles from './styles'

const BankAccountDrawer = ({ show, onClose }) => {
  const { getBankAccounts, fetchingBankAccounts } = useBankAccount()
  const { step, setStep, handleOnClose, showBack, onBack } = useManageSteps({ onClose })

  useEffect(() => {
    if (show) {
      getBankAccounts()
    }
  }, [getBankAccounts, show])

  const onCreateBankAccount = () => {
    setStep(steps.verifyAccountStep)
  }

  return (
    <Drawer show={show} onClose={handleOnClose} options={{ showHeaderActions: false, useBlurForBackdrop: true }}>
      <Styles.Container>
        <Header onClose={handleOnClose} onBack={onBack} showBack={showBack} />
        <Loading show={fetchingBankAccounts}>
          <div>
            {step === steps.bankAccountStep && <BankAccountStep onCreateBankAccount={onCreateBankAccount} />}
            {step === steps.verifyAccountStep && <VerifyAccountStep />}
          </div>
        </Loading>
      </Styles.Container>
    </Drawer>
  )
}

export default BankAccountDrawer
